import type { CrossFlowInteractedUIActionSubjectIDs, CrossFlowViewedScreenNames } from '@atlassian/surface-analytics-specs';

import type { FeatureEvents, ScreenEvent, UIEvent } from '../new-analytics-types';
import { Action, ActionSubject } from '../new-analytics-types';

type ScreenKeys = 'addAppSelectScreenEvent';

type UIEventKeys = 'enterpriseQuotingBannerCard' | 'tryItNow' | 'seeFeatures' | 'discoverNewProduct';

export const addAppSelectScreen: CrossFlowViewedScreenNames = 'addAppSelectScreen';
const tryItNowActionSubjectId: CrossFlowInteractedUIActionSubjectIDs = 'tryItNow';
const seeFeaturesActionSubjectId: CrossFlowInteractedUIActionSubjectIDs = 'seeFeatures';

export const addAppEvents: FeatureEvents<ScreenKeys, UIEventKeys, string, string> = {
  confluenceSpec:
    'https://hello.atlassian.net/wiki/spaces/~7120208cbfeee96f8441dea1f49b9ee065b281/pages/4917723927/TwC+Add+Collection+Analytics+Spec',
  screen: {
    addAppSelectScreenEvent: (attributes: { apps?: string[]; collections?: string[]; recommendedProductIds: string[] }): ScreenEvent => ({
      data: {
        name: addAppSelectScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/85285',
    }),
  },
  ui: {
    tryItNow: (attributes: { app?: string; collection?: string; isEnterpriseApp?: boolean; targetProductId?: string }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubjectId: tryItNowActionSubjectId,
        actionSubject: ActionSubject.Button,
        source: addAppSelectScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/85288',
    }),
    seeFeatures: (attributes: { app?: string; collection?: string; targetProductId?: string }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Link,
        actionSubjectId: seeFeaturesActionSubjectId,
        source: addAppSelectScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/86033',
    }),
    enterpriseQuotingBannerCard: (attributes: { appType?: string; source: string }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Card,
        actionSubjectId: 'enterpriseQuotingBannerCard',
        source: attributes.source,
        ...(attributes.appType ? { attributes: { appType: attributes.appType } } : {}),
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/59169',
    }),
    discoverNewProduct: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'discoverNewProduct',
        source: addAppSelectScreen,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/52877',
    }),
  },
  track: {},
  operational: {},
};
